<template>
    <div :class="{'literacy-numeracy-wrapper': question}">
        <template v-if="showedInfo">
            <div v-if="pending" class="literacy-numeracy-pending">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
            <div v-if="error">{{error}}</div>
            <div v-if="question">
                <br>
                <additional-component @input="onInputAdditional" :value="answer" :id="question.id"/>
                <br>
            </div>
        </template>

        <template v-else>
            <info-block @success="showedInfo = true; $root.$emit('aside', true)" :title="infoData.title" :content="infoData.content"></info-block>
        </template>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'
    import AdditionalComponent from './questions/index'
    import InfoBlock from './info'
    import InfoData from './data'

    export default {
        data () {
            return {
                pending: true,
                error: '',
                showedInfo: false
            }
        },
        props: {
            options: Object
        },
        components: {
            AdditionalComponent,
            InfoBlock
        },
        computed: {
            ...mapState('session', ['route']),
            ...mapGetters('questions', ['question', 'answer']),
            infoData () {
                return InfoData[this.route]
            }
        },
        mounted () {
            this.init()
        },
        methods: {
            init () {
                this.$root.$emit('aside', false)
                this.$store.dispatch('questions/init', {
                    stage: this.options.stage
                })
                    .then(() => this.pending = false)
                    .catch(this.onError)
            },
            onError () {
                this.pending = false
                this.error = 'Возникла ошибка, перезагрузите страницу'
            },
            onInputAdditional (val) {
                this.$store.dispatch('questions/answer', val)
            }
        },
        watch: {
            route () {
                this.showedInfo = false
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .literacy-numeracy-wrapper {
        height 100%
        display flex
        flex-flow column nowrap
        justify-content center
    }
    .literacy-numeracy-pending {
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        display flex
        align-items center
        justify-content center
        background-color rgba(0, 0, 0, 0.7)
    }
</style>
